/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import RaceContainer from './RaceContainer'
import AppHeaderForRace from '../../components/layout/AppHeaderForRace'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/race/:raceId',
      name: 'race',
      components: {
        default: RaceContainer,
        header: AppHeaderForRace,
      },
      beforeEnter: allowOnlyAuthorized()
    },
  ])
}
